<template>
  <main-layout>
    <div slot="left-side">
      <menubar screenIdParam="M-06-28"></menubar>
    </div>
    <el-row slot="header">
      <headTitle class="cancel-width">
        <label slot="title">
          {{ $t("title.system.account.title") }}
        </label>
        <lvory-but
          @click="backBuildingDetail"
          slot="cancel">
            {{ $t("button.common.data.cancel") }}
        </lvory-but>
        <narrowDown @click="updateAccount" slot="create">
          {{ $t("button.common.data.create") }}
        </narrowDown>
      </headTitle>
    </el-row>
    <div slot="body" style="width: 100%">
      <!-- subtitle -->
      <div class="main-title">
        {{ $t("label.system.account.prompt.accountEdit") }}
      </div>
      <el-row >
        <span class="star-color">* </span>
        <span class="c-ivory01">{{ $t("label.common.must") }}</span>
      </el-row>

      <el-form
        ref="ruleForm"
        class="account-edit"
        label-position="left"
        :rules="rules"
        :model="accountInfo"
      >
      <div class="info-margin-top">
        <div class="float-left">
          <span class="title-div">
            {{ $t("label.system.account.create.baseInfo") }}
          </span>
        </div>

        <div class="info-margin-left">
          <!-- ユーザー名 -->
          <el-form-item
            class="asterisk line-height-44"
            prop="fullname"
            label="ユーザー名"
            label-width="200px">
            <el-input
              maxlength="20"
              class="new-input-style show-word-limt-input-iot"
              show-word-limit
              v-model="accountInfo.fullname"
              placeholder="ユーザー名"
            ></el-input>
          </el-form-item>
          <!-- 電話番号 -->
          <el-form-item
            prop="telNo"
            label="電話番号"
            class="line-height-44"
            label-width="200px">
            <el-input
              maxlength="20"
              class="new-input-style show-word-limt-input-iot"
              show-word-limit
              v-model="accountInfo.telNo"
              :placeholder="$t('label.system.account.create.telNo')"
            ></el-input>
          </el-form-item>
          <!-- メールアドレス -->
          <el-form-item
            prop="email"
            class="asterisk line-height-44"
            label="メールアドレス"
            label-width="200px">
            <div class="edit-content">
              {{accountInfo.email}}
            </div>
          </el-form-item>
          <!--  サービス開通日時  -->
          <el-row type="flex" align="middle">
            <div class="float-left">
              <el-form-item
                label-width="200px"
                class="asterisk"
                prop="serviceStartDate"
                label="サービス開通日時">
                <div class="el-date-editor-box">
                  <el-date-picker
                    @blur="this.$reset"
                    :clearable="false"
                    class="date-picker-background-color"
                    value-format="yyyy/MM/dd"
                    :format="'yyyy年M月d日'+' '+'('+ [startWeek]+')'"
                    v-model="accountInfo.serviceStartDate"
                  />
                </div>
              </el-form-item>
            </div>
            <div class="float-left m-left-2">
              <el-form-item>
                <el-select
                  :clearable="false"
                  class="time-select"
                  placeholder=""
                  v-model="accountInfo.startTime"
                  >
                    <el-option
                      v-for="item in timeList"
                      :value="item"
                      :key="item"
                      :label="item">
                    </el-option>
                    <!--  -->
                </el-select>
              </el-form-item>
            </div>
          </el-row>
          <!--  サービス停止日時  -->
          <el-row type="flex" align="middle">
            <div class="float-left">
              <el-form-item
                label-width="200px"
                prop="serviceEndDate"
                label="サービス停止日時">
                <div class="el-date-editor-box">
                  <el-date-picker
                    @blur="this.$reset"
                    @change="changeEndDate"
                    class="date-picker-background-color"
                    :clearable="false"
                    value-format="yyyy/MM/dd"
                    :format="'yyyy年M月d日'+' '+'('+ [endWeek]+')'"
                    v-model="accountInfo.serviceEndDate"
                  />
                </div>
              </el-form-item>
            </div>
            <div class="float-left m-left-2">
              <el-form-item>
                <el-select
                  :clearable="false"
                  class="time-select"
                  placeholder=""
                  v-model="accountInfo.endTime"
                  >
                    <el-option
                      v-for="item in timeList"
                      :value="item"
                      :key="item"
                      :label="item">
                    </el-option>
                    <!--  -->
                </el-select>
              </el-form-item>
            </div>
            <div class="float-left m-left-2">
              <select-btn @click="clearEndDate" class="clear-width">
                クリア
              </select-btn>
            </div>
          </el-row>
        </div>
      </div>

      <hr class="delimiter margin-top-0" />
      <div class="float-left">
        <span class="title-div">
          {{ $t("label.system.account.create.accountAuthority") }}
        </span>
      </div>
      <el-row class="info-margin-left">
          <!--  アカウント種別  -->
          <el-form-item
            label="アカウント種別"
            label-width="200px"
            prop="accountType"
            class="asterisk">
            <sp-smart-lable-button
            >
            <div class="account-type-name">
              {{accountInfo.accountType.name}}
            </div>
            </sp-smart-lable-button>
          </el-form-item>
      </el-row>
      <el-row class="info-margin-left">
          <el-form-item
            class="asterisk"
            label-width="200px"
            size="small"
            :label="$t('label.system.account.create.role')"
            prop="roles"
          >
            <el-checkbox-group
              v-model="accountInfo.roles"
              @change="selectRole(accountInfo.roles)"
            >
              <el-checkbox :label="role.code" v-for="role in roles" :key="role.code" :disabled="role.isDisabled">
                {{ role.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
      </el-row>
      <el-row class="info-margin-left">
        <!-- オーナーID -->
        <el-form-item
          v-show="ownerShow"
          label="オーナーID"
          class="line-height-44"
          label-width="200px">
          <div class="edit-content">
            {{accountInfo.ownerExId}}
          </div>
        </el-form-item>
        <!-- オーナー名 -->
        <el-form-item
          class="asterisk m-bottom-5 line-height-44"
          v-show="ownerShow"
          :rules="[
            {
              required: this.ownerCheck,
              message: 'オーナー名は必須項目です',
              trigger: 'change'
            }
          ]"
          prop="ownerName"
          label="オーナー名"
          label-width="200px">
          <div class="float-left">
            <div class="edit-content">
              {{accountInfo.ownerName}}
            </div>
          </div>
          <!-- <select-btn
            class="selectBtn float-left margin-left-3"
            @click="searchOwnerPopup"
            >{{ $t("button.common.select") }}
          </select-btn> -->
        </el-form-item>
      </el-row>

      <el-row class="info-margin-left">
        <!-- テナントID -->
        <el-form-item
          v-show="tenant"
          class="line-height-44"
          label="テナントID"
          label-width="200px">
          <div class="edit-content">
            {{accountInfo.tenantExId}}
          </div>
        </el-form-item>
        <!-- テナント名 -->
        <el-form-item
          :rules="[
            {
              required: this.tenantCheck,
              message: 'テナント名は必須項目です',
              trigger: 'change'
            }
          ]"
          class="asterisk m-bottom-5 line-height-44"
          v-show="tenant"
          prop="tenantName"
          label="テナント名"
          label-width="200px">
          <div class="float-left">
            <div class="edit-content">
              {{accountInfo.tenantName}}
            </div>
          </div>
          <!-- <select-btn
            class="selectBtn float-left margin-left-3"
            @click="searchTenantPopup"
            >{{ $t("button.common.select") }}
          </select-btn> -->
        </el-form-item>
      </el-row>

      <el-row class="info-margin-left">
        <!-- アカウントID -->
        <el-form-item
          class="asterisk m-bottom-5 line-height-44"
          v-show="account"
          prop="accountExId"
          label="アカウントID"
          label-width="200px">
          <div class="float-left">
            <div class="edit-content">
              {{accountInfo.accountExId}}
            </div>
          </div>
        </el-form-item>
      </el-row>

      <hr v-if="accountInfo.orgSsoTargetFlag" class="delimiter margin-top-0" />
      <div v-if="accountInfo.orgSsoTargetFlag" class="float-left">
        <span class="title-div">
          SSO
        </span>
      </div>

      <el-row v-if="accountInfo.orgSsoTargetFlag" class="info-margin-left">
        <!-- SSO対象 -->
        <el-form-item
          class="m-bottom-5 line-height-44"
          prop="ssoTargetFlag"
          label="SSO対象"
          label-width="200px">
          <div class="float-left">
            <el-switch
              v-model="accountInfo.ssoTargetFlag"
              :disabled="!accountInfo.ssoTargetChangeEnableFlag"
              :active-value="true"
              :inactive-value="false">
            </el-switch>
          </div>
        </el-form-item>
      </el-row>

      <el-row v-if="accountInfo.orgSsoTargetFlag && accountInfo.ssoTargetFlag" class="info-margin-left">
        <!-- 認証用ID -->
        <el-form-item
          class="m-bottom-5 line-height-44"
          prop="idpUuid"
          label="認証用ID"
          label-width="200px">
          <div class="float-left">
            <el-input
              maxlength="256"
              class="new-input-style"
              v-model="accountInfo.idpUuid"
              placeholder=""
            ></el-input>
          </div>
        </el-form-item>
      </el-row>

      <narrowDown
        class="m-left-400 m-top-20 m-bottom-5"
        @click="updateAccount">
        {{ $t("button.common.data.create") }}
      </narrowDown>

      </el-form>

      <!-- No.123 -->

      <el-row v-if="buildingListShowFlg">
          <hr class="delimiter margin-top-0" />
          <span class="title-div">
            {{ $t("label.system.account.detail.glbl") }}
          </span>
          <el-table
            class="m-top-5 table-header-th-top-0"
            style="width: 100% !important;"
            :data="buildingList"
            header-cell-class-name="sp-table-cell"
          >
            <!-- ビルID -->
            <el-table-column
              class-name="col-3"
              prop="exId"
              :label="$t('label.system.account.edit.buildingExId')"
            />

            <!-- ビル名 -->
            <el-table-column
              class-name="col-5"
              prop="name"
              :label="$t('label.system.account.edit.buildingName')"
            />

            <!-- 住所 -->
            <el-table-column
              class-name="col-7"
              prop="buildingAddress"
              :label="$t('label.system.account.edit.address')"
            />

            <!-- フロア数 -->
            <el-table-column
              class-name="col-5"
              prop="buildingfloors"
              label="フロア総階数"
            />
          </el-table>
      </el-row>

      <el-row class="margin-left" v-if="areaListShowFlg">
        <hr class="delimiter margin-top-0" />
        <el-col :span="12">
          <span class="title-div">
            {{ "関連工リア" }}
          </span>
          <el-table
            class="m-top-5 table-header-th-top-0"
            style="width: 100% !important;"
            :data="areaList"
            header-cell-class-name="sp-table-cell"
          >
            <!-- エリア名 -->
            <el-table-column
              prop="areaName"
              class-name="col-4"
              :label="$t('label.system.account.edit.areaName')"
            />

            <!-- 所在 -->
            <el-table-column
              class-name="col-6"
              prop="areaLocation"
              :label="$t('label.system.account.edit.areaLocation')"
            />
          </el-table>
        </el-col>
      </el-row>

      <loading-dialog :dialogVisible="showLoading" />

      <!-- オーナー選択子画面 -->
      <owner-search-popup
        :includeDeleteDataFlag="false"
        :visible.sync="ownerSearchFlg"
        @on-selected="getOwnerInfo"
      />

      <!-- テナント選択子画面 -->
      <tenant-search-popup
        :includeDeleteDataFlag="false"
        :visible.sync="tenantSearchFlg"
        @on-selected="getTenantInfo"
      />

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>

    </div>
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import SystemManageApi from "@/api/SystemManageApi";
import headTitle from "@/components/common/head/head";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import NewDesignLayout from "@/layout/NewDesignLayout";
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import Menubar from "@/components/leftmenu/DashBoard";
import errorCodeMsg from "@/utils/error-code-msg"
import moment from 'moment';
import selectBtn from "@/components/common/generalButton/Select"
import SpSmartLableButton from "@/components/common/sp-smart-lable-button";
import OwnerSearchPopup from "@/components/system/popup/OwnerSearchPopup";
import TenantSearchPopup from "@/components/system/popup/TenantSearchPopup";
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import statusErrorCodeMsg from "@/utils/status-error-msg"

const weeksDay = ["日", "月", "火", "水", "木", "金", "土"];
export default {
  name: "AccountEdit",
  components: {
    MainLayout: NewDesignLayout,
    LoadingDialog: LoadingDialog,
    headTitle,
    narrowDown,
    Menubar,
    SpSmartLableButton,
    selectBtn,
    OwnerSearchPopup,
    TenantSearchPopup,
    elDialogPrompt,
    LvoryBut
  },
  data() {

    var validateStartDate = (rule,value,callback) => {
      if(this.$checkDateChange(this.firstServiceStartDt,this.accountInfo.serviceStartDate, this.accountInfo.startTime)) {
        this.$checkServceStartDate(this.accountInfo.serviceStartDate, this.accountInfo.startTime,callback);
      }
      if(this.accountInfo.serviceEndDate != ''&& this.accountInfo.serviceEndDate !=null){
        if(Date.parse(value) >  Date.parse(this.accountInfo.serviceEndDate)){
          callback(new Error(this.$t('message.common.dateSizeRelationship',{
            field1 :this.$t('label.system.messageSearch.startDateEnd'),
            field2 :this.$t('label.system.messageSearch.startDateStart')
          })))
        }else if(Date.parse(value) ==  Date.parse(this.accountInfo.serviceEndDate)){
          if(null != this.accountInfo.startTime && null != this.accountInfo.endTime){
            let lastDataTime = value +" "+ this.accountInfo.startTime
            let nextDataTime =this.accountInfo.serviceEndDate+" " + this.accountInfo.endTime
            if(Date.parse(lastDataTime)<Date.parse(nextDataTime)){
              callback()
            }else{
              callback(new Error(this.$t('message.common.dateSizeRelationship',{
                field1 :this.$t('label.system.messageSearch.startDateEnd'),
                field2 :this.$t('label.system.messageSearch.startDateStart')
              })))
            }
          }else if(null != this.accountInfo.startTime && null==this.accountInfo.endTime ){
            callback();
          }else if(null == this.accountInfo.startTime && null!=this.accountInfo.endTime ){
            if(this.accountInfo.endTime == "00:00"){
              callback(new Error(this.$t('message.common.dateSizeRelationship',{
                field1 :this.$t('label.system.messageSearch.startDateEnd'),
                field2 :this.$t('label.system.messageSearch.startDateStart')
              })))
            }else{
              callback();
            }
          }
          else{
            callback();
          }
        }else{
          callback();
        }
      }else{
          callback();
      }
    }
    var validateEndDate = (rule,value,callback) =>{
      this.$refs["ruleForm"].validateField("serviceStartDate");
      this.$checkServceEndDate(this.accountInfo.serviceEndDate, this.accountInfo.endTime,callback);
      callback()
      // if(this.accountInfo.serviceStartDate != ''&& this.accountInfo.serviceStartDate !=null){
      //   if(Date.parse(value) <  Date.parse(this.accountInfo.serviceStartDate)){
      //     callback(new Error(this.$t('message.common.dateSizeRelationship',{
      //       field1 :this.$t('label.system.messageSearch.startDateEnd'),
      //       field2 :this.$t('label.system.messageSearch.startDateStart')
      //     })))
      //   }else if(Date.parse(value) ==  Date.parse(this.accountInfo.serviceStartDate)){
      //     if(null != this.accountInfo.startTime && null != this.accountInfo.endTime){
      //       let lastDataTime = this.accountInfo.serviceStartDate +" "+ this.accountInfo.startTime
      //       let nextDataTime = value+" " + this.accountInfo.endTime
      //       if(Date.parse(lastDataTime)<Date.parse(nextDataTime)){
      //         callback()
      //       }else{
      //         callback(new Error(this.$t('message.common.dateSizeRelationship',{
      //           field1 :this.$t('label.system.messageSearch.startDateEnd'),
      //           field2 :this.$t('label.system.messageSearch.startDateStart')
      //         })))
      //       }
      //     }else if(null != this.accountInfo.startTime && null==this.accountInfo.endTime ){
      //       callback();
      //     }else if(null == this.accountInfo.startTime && null!=this.accountInfo.endTime ){
      //       if(this.accountInfo.endTime == "00:00"){
      //         callback(new Error(this.$t('message.common.dateSizeRelationship',{
      //           field1 :this.$t('label.system.messageSearch.startDateEnd'),
      //           field2 :this.$t('label.system.messageSearch.startDateStart')
      //         })))
      //       }else{
      //         callback();
      //       }
      //     }
      //     else{
      //       callback();
      //     }
      //   }else{
      //     callback();
      //   }
      // }else{
      //     callback();
      // }
    }
    const checkIdpUuid = (rules, value, callback) => {
      if(this.accountInfo.ssoTargetFlag) {
        if (value == '' ||  value == null || value == undefined) {
          callback(new Error(
            this.$t("message.common.validation.required", {
              field: '認証用ID'
            })
          ))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      firstServiceStartDt:null,
      msgParam: this.$t("message.common.validation.saveMessage",{
        field: "アカウント"
      }),
      buildingListShowFlg:false,
      areaListShowFlg:false,
      centerDialogVisibleIsShow: false,
      startWeek:null,
      endWeek:null,
      ownerSearchFlg: false,
      tenantSearchFlg: false,
      ownerCheck: false,
      tenantCheck: false,
      accountCheck: false,
      ownerShow:false,
      tenant:false,
      account:false,
      timeList:[],
      imgUrl: null,
      paramsAccountId: null,
      showLoading: false,
      accountInfo: {
        startTime: null,
        endTime: null,
        accountId: null,
        accountExId: null,
        fullname: null,
        telNo: null,
        email: null,
        serviceStartDate: null,
        serviceEndDate: null,
        lockStatus: null,
        accountType: {
          code: null,
          name: null,
        },
        roles: [],
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        tenantId: null,
        tenantExId: null,
        tenantName: null,
        orgSsoTargetFlag: false,
        ssoTargetChangeEnableFlag: false,
        ssoTargetFlag: false,
        idpUuid: null
      },
      buildingList: [
        {
          exId: null,
          name: null,
          buildingAddress: null,
          buildingfloors: null,
        },
      ],
      areaList: [
        {
          areaName: null,
          areaLocation: null,
        },
      ],
      roles: [
        {
          code: null,
          name: null,
          isDisabled: null,
        },
      ],
      accountType: [
        {
          value: "01",
          type: this.$t("label.system.account.accountType.SB"),
        },
        {
          value: "02",
          type: this.$t("label.system.account.accountType.BM"),
        },
        {
          value: "03",
          type: this.$t("label.system.account.accountType.owner"),
        },
        {
          value: "04",
          type: this.$t("label.system.account.accountType.tenant"),
        },
        {
          value: "05",
          type: this.$t("label.system.account.accountType.iPad"),
        },
      ],
      serviceStartDate: {
        disabledDate: (time) => {
          let endDateVal = this.accountInfo.serviceEndDate;
          if (endDateVal) {
            return (
              time.getTime() >
              new Date(endDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        },
      },
      serviceEndDate: {
        disabledDate: (time) => {
          let beginDateVal = this.accountInfo.serviceStartDate;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() + 1 * 24 * 60 * 60 * 1000
            );
          }
        },
      },
      rules:{
        serviceStartDate:[
          { validator: validateStartDate, trigger: 'change' },
          {
            required: true,
            trigger: 'change',
            message: this.$t('message.common.validation.required', {
              field: this.$t('label.system.account.create.serviceStartDate')
            })
          }
        ],
        serviceEndDate:[
          { validator: validateEndDate, trigger: 'change' }
        ],
        // ユーザー名  チェック ・桁数チェック ・型チェック ・必須チェック
        fullname: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('message.common.validation.required', {
              field: this.$t('label.system.account.create.fullname')
            })
          },
          {
            max: 20,
            trigger: 'change',
            message: this.$t('message.common.validation.max', {
              field: this.$t('label.system.account.create.fullname'),
              length: 20
            })
          }
        ],
         // 電話番号  チェック ・桁数チェック ・型チェック
        telNo: [
          {
            max: 20,
            trigger: 'change',
            message: this.$t('message.common.validation.telMessageLength', {
              field: this.$t('label.system.account.create.telNo'),
              length: 20
            })
          },
          {
            // pattern: /^[0-9]{1,4}-[0-9]{1,4}-[0-9]{1,4}$/, modify by mxq
            pattern: /^[0-9/-]*$/,
            trigger: 'change',
            message: this.$t('message.common.validation.telNoMessage')
          }
        ],
        // メールアドレス  チェック ・桁数チェック ・型チェック ・必須チェック
        email: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('message.common.validation.required', {
              field: this.$t('label.system.account.create.email')
            })
          },
          {
            max: 319,
            trigger: 'change',
            message: this.$t('message.common.validation.max', {
              field: this.$t('label.system.account.create.email'),
              length: 319
            })
          },
          {
            pattern: /^[!#$%'*+\-0-9=?A-Z^_`a-z{}~]+(\.[!#$%'*+\-0-9=?A-Z^_`a-z{}~]+)*@(?![\d]+(\.[\d]+)*$)[!#$%'*0-9=?A-Z^`a-z{}~]+([!#$%'*\-0-9=?A-Z^_`a-z{}~]*[!#$%'*0-9=?A-Z^`a-z{}~]+)*(\.[!#$%'*0-9=?A-Z^`a-z{}~]+([!#$%'*\-0-9=?A-Z^_`a-z{}~]*[!#$%'*0-9=?A-Z^`a-z{}~]+)*)+$/,
            trigger: 'change',
            message: this.$t('message.common.validation.emailType')
          }
        ],
        idpUuid: [
          {
            validator: checkIdpUuid,
            trigger: 'change',
          },
          {
            max: 256,
            trigger: 'change',
            message: this.$t('message.common.validation.max', {
              field: '認証用ID',
              length: 256
            })
          }
        ],
        // アカウント種別  チェック ・必須チェック
        accountType: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('message.common.validation.required', {
              field: this.$t('label.system.account.create.accountType')
            })
          }
        ],

        // ロール  チェック ・必須チェック
        roles: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('message.common.validation.required', {
              field: this.$t('label.system.account.create.role')
            })
          }
        ],
      },
    };
  },
  watch: {
    "accountInfo.accountType.code"(val) {
      switch (val) {
        case "01": {
          this.ownerShow = false
          this.tenant = false
          this.account = false
          this.ownerCheck = false
          this.tenantCheck = false
          this.accountCheck = false
          break;
        }
        case "02": {
          this.ownerShow = false
          this.tenant = false
          this.account = false
          this.ownerCheck = false
          this.tenantCheck = false
          this.accountCheck = false
          this.$refs['ruleForm'].validateField(["tenantName"]);

          break;
        }
        case "03": {
          this.ownerShow = true
          this.tenant = false
          this.account = false
          this.ownerCheck = true
          this.tenantCheck = false
          this.accountCheck = false
          break;
        }
        case "04": {
          this.ownerShow = false
          this.tenant = true
          this.account = false
          this.ownerCheck = false
          this.tenantCheck = true
          this.accountCheck = false
          break;
        }
        case "05": {
          this.ownerShow = false
          this.tenant = false
          this.account = true
          this.ownerCheck = false
          this.tenantCheck = false
          this.accountCheck = true
          break;
        }
        default: {
          this.roles = [];
          this.ownerShow = false
          this.tenant = false
          this.account = false
          this.ownerCheck = false
          this.tenantCheck = false
          this.accountCheck = true
        }
      }
    },
    "accountInfo.serviceStartDate"(val) {
      this.startWeek=weeksDay[new Date(val).getDay()]
      // this.accountInfo.startTime = "00:00"
    },
    "accountInfo.serviceEndDate"(val) {
      this.endWeek=weeksDay[new Date(val).getDay()]
      // this.accountInfo.endTime = "00:00"
    }
  },
  created() {
    this.timeList=this.timeSlot()
    this.$authCheck("010103")
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/accounts/search",
        title: "label.router.account",
      },
      {
        path: "",
        title: "label.router.accountDeatil",
      },
      {
        path: "",
        title: "label.router.accountEdit",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)

    this.roles = [];
    this.areaList = [];
    this.buildingList = [];
    this.paramsAccountId = this.$route.params.accountId;
  },
  mounted() {
    this.detailAccount();
  },
  methods: {

    changeEndDate() {
      if(!this.accountInfo.endTime) {
        this.accountInfo.endTime = "00:00"
      }
    },

    disabledCheckbox(){
      var disableFlag = true;
      if (this.$IsSBManager()) {
        disableFlag = false;
      } else if (this.$IsOwnerManager() && this.accountInfo.accountType.code == '04') {
        disableFlag = false;
      } else if (this.$IsTenantManager()) {
         disableFlag = false
      }
      for (let i = 0; i < this.roles.length; i++) {
          this.roles[i].isDisabled = disableFlag;
      }
    },


    searchTenantPopup() {
      this.tenantSearchFlg = true;
    },

    getTenantInfo(tenant) {
      this.accountInfo.tenantId = tenant.tenantId;
      this.accountInfo.tenantExId = tenant.tenantExId;
      this.accountInfo.tenantName = tenant.tenantName;
    },

    searchOwnerPopup() {
      this.ownerSearchFlg = true;
    },

    getOwnerInfo(owner) {
      this.accountInfo.ownerId = owner.id;
      this.accountInfo.ownerExId = owner.exId;
      this.accountInfo.ownerName = owner.name;
    },

    getImageFile(file) {
      this.tenantCreate.imageFile = file;
      if (file) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imgUrl = reader.result;
        };
      } else {
        this.imgUrl = null;
      }
    },
    /**
     * 返回 アカウント一覧
     */
    backAccountSearch() {
      this.$router.push({
        name: "system-account-search",
      });
    },

    /**
     * アカウント情報戻る
     */
    backBuildingDetail() {
      this.$router.push({
        name: "system-account-detail",
        params: {
          accountId: this.paramsAccountId,
        },
      });
    },

    /**
     * アカウント情報取得
     */
    detailAccount() {
      this.showLoading = true;
      SystemManageApi.detailAccount(this.paramsAccountId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          this.accountInfo.accountId = data.body.accountDetail.accountId;
          if(data.body.accountDetail.accountType === "05") {
            this.accountInfo.accountExId = data.body.accountDetail.accountExId;
          }
          this.accountInfo.fullname = data.body.accountDetail.fullname;
          this.accountInfo.telNo = data.body.accountDetail.telNo;
          this.accountInfo.email = data.body.accountDetail.email;
          this.firstServiceStartDt = moment(new Date(data.body.accountDetail.serviceStartDate)).format("YYYY/MM/DD HH:mm")
          this.accountInfo.serviceStartDate = moment(new Date(data.body.accountDetail.serviceStartDate)).format("YYYY/MM/DD");
          this.accountInfo.startTime = moment(new Date(data.body.accountDetail.serviceStartDate)).format("HH:mm")
          if(data.body.accountDetail.serviceEndDate) {
            this.accountInfo.serviceEndDate = moment(new Date(data.body.accountDetail.serviceEndDate)).format("YYYY/MM/DD");
            this.accountInfo.endTime = moment(new Date(data.body.accountDetail.serviceEndDate)).format("HH:mm")
          }
          this.accountInfo.lockStatus = data.body.accountDetail.lockStatus;
          this.accountInfo.ownerId = data.body.accountDetail.ownerId;
          this.accountInfo.ownerExId = data.body.accountDetail.ownerExId;
          this.accountInfo.ownerName = data.body.accountDetail.ownerName;
          this.accountInfo.tenantId = data.body.accountDetail.tenantId;
          this.accountInfo.tenantExId = data.body.accountDetail.tenantExId;
          this.accountInfo.tenantName = data.body.accountDetail.tenantName;
          this.accountInfo.roles = data.body.accountDetail.roles;
          this.accountInfo.orgSsoTargetFlag = data.body.accountDetail.orgSsoTargetFlag;
          this.accountInfo.ssoTargetChangeEnableFlag = data.body.accountDetail.ssoTargetChangeEnableFlag;
          this.accountInfo.ssoTargetFlag = data.body.accountDetail.ssoTargetFlag;
          this.accountInfo.idpUuid = data.body.accountDetail.idpUuid;
          // deal auth
          for (let role of data.body.accountDetail.roles) {
            if (role === "0103" || role === "0303" || role === "0202" || role ==="0201" || role ==="0501") {
              this.buildingListShowFlg = true;
            }
          }
          this.roles = [];
          this.setupRoles(data.body.accountDetail.accountType);

          this.selectRole(this.accountInfo.roles);

          this.buildingList = [];
          for (let building of data.body.buildingList) {
            this.buildingList.push({
              exId: building.exId,
              name: building.name,
              buildingAddress: building.postCode + " " + building.address,
              buildingfloors:
                this.$t("label.system.account.edit.aboveFloor") +
                building.aboveFloorCount +
                this.$t("label.system.account.edit.floor") +
                "/" +
                this.$t("label.system.account.edit.belowFloor") +
                building.belowFloorCount +
                this.$t("label.system.account.edit.floor"),
            });
          }

          this.areaList = [];
          for (let area of data.body.areaList) {
            this.areaList.push({
              areaName: area.areaName,
              areaLocation:
                area.ownerName + " " + area.buildingName + " " + area.floorName,
            });
          }

          this.disabledCheckbox()
        })
        .finally(() => {
          this.showLoading = false;
        });
    },

    clearEndDate () {
      this.accountInfo.serviceEndDate = null
      this.accountInfo.endTime = null
    },

    /**
     * ロールコードリストを設定する
     */
    setupRoles(type) {
      if(type == '04'){
        this.areaListShowFlg = true;
      }
      switch (type) {
        case "01": {
          this.accountInfo.accountType.code = "01";
          this.accountInfo.accountType.name = this.$t(
            "label.system.account.accountType.SB"
          );
          this.roles = [
            {
              code: "0101",
              name: this.$t("label.system.account.role.SBSystemManager"),
              isDisabled: false,
            },
            {
              code: "0102",
              name: this.$t("label.system.account.role.SBCustomerManager"),
              isDisabled: false,
            },
            {
              code: "0103",
              name: this.$t(
                "label.system.account.role.SBCustomerpersonInCharge"
              ),
              isDisabled: false,
            },
          ];
          break;
        }
        case "02": {
          this.accountInfo.accountType.code = "02";
          this.accountInfo.accountType.name = this.$t(
            "label.system.account.accountType.BM"
          );
          this.roles = [
            {
              code: "0201",
              name: this.$t("label.system.account.role.BMStaff"),
              isDisabled: false,
            },
            {
              code: "0202",
              name: this.$t(
                "label.system.account.role.BMCustomerPersonInCharge"
              ),
              isDisabled: false,
            },
          ];
          break;
        }
        case "03": {
          this.accountInfo.accountType.code = "03";
          this.accountInfo.accountType.name = this.$t(
            "label.system.account.accountType.owner"
          );
          this.roles = [
            {
              code: "0301",
              name: this.$t("label.system.account.role.ownerManager"),
              isDisabled: false,
            },
            {
              code: "0302",
              name: this.$t("label.system.account.role.ownerCustomerManager"),
              isDisabled: false,
            },
            {
              code: "0303",
              name: this.$t(
                "label.system.account.role.ownerCustomerPersonInCharge"
              ),
              isDisabled: false,
            },
          ];
          break;
        }
        case "04": {
          this.accountInfo.accountType.code = "04";
          this.accountInfo.accountType.name = this.$t(
            "label.system.account.accountType.tenant"
          );
          this.roles = [
            {
              code: "0401",
              name: this.$t("label.system.account.role.tenantManeger"),
              isDisabled: false,
            },
            {
              code: "0402",
              name: this.$t("label.system.account.role.tenantCompanyWManeger"),
              isDisabled: true,
            },
            {
              code: "0403",
              name: this.$t("label.system.account.role.tenantCompanyWUser"),
              isDisabled: true,
            },
            {
              code: "0404",
              name: this.$t("label.system.account.role.tenantUser"),
              isDisabled: false,
            },
          ];
          break;
        }
        case "05": {
          this.accountInfo.accountType.code = "05";
          this.accountInfo.accountType.name = this.$t(
            "label.system.account.accountType.iPad"
          );
          this.roles = [
            {
              code: "0501",
              name: this.$t("label.system.account.role.iPadUser"),
              isDisabled: false,
            },
          ];
          break;
        }
        default: {
          this.roles = [];
        }
      }
    },

    timeSlot () {
        let step = 15
        var date = new Date("2021-01-14 00:00:00")
        let timeArr = [];
        var slotNum = 24*60/step
        for (var f = 0; f < slotNum; f++) {
            var time = new Date(Number(date.getTime()) + Number(step*60*1000*f))
            var hour = '', sec = '';
            time.getHours() < 10 ? hour = '0' + time.getHours() : hour = time.getHours()
            time.getMinutes() < 10 ? sec = '0' + time.getMinutes() : sec = time.getMinutes()
            timeArr.push(hour + ':' + sec)
        }
        return timeArr
    },

    /**
     * アカウント情報 更新 提示框
     */
    updateAccount() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.centerDialogVisibleIsShow = true
        }
      });
    },

    isPassParam(param){
      if(param){
        this.doneUpdateAccount()
      }
    },

    /**
     * アカウント情報 更新
     */
    doneUpdateAccount() {
      this.centerDialogVisibleIsShow = false;
      this.showLoading = true;
      let accountId = this.paramsAccountId;
      let serviceStartDate = this.accountInfo.serviceStartDate + ' ' +this.accountInfo.startTime
      let serviceEndDate = null
      if(this.accountInfo.serviceEndDate && this.accountInfo.endTime) {
        serviceEndDate = this.accountInfo.serviceEndDate + ' ' +this.accountInfo.endTime
      }
      let postData = {
        fullname: this.accountInfo.fullname,
        telNo: this.accountInfo.telNo,
        serviceStartDate: serviceStartDate,
        serviceEndDate: serviceEndDate,
        roles: this.accountInfo.roles,
        ssoTargetFlag: this.accountInfo.ssoTargetFlag,
        idpUuid: this.accountInfo.idpUuid,
      };
      SystemManageApi.updateAccount(accountId, postData)
        .catch((error) => {
          this.showLoading = false
          errorCodeMsg(error, this)
        })
        .then(({data}) => {
          this.showLoading = false
          if (!statusErrorCodeMsg(data.statusCode, this, 'AccountUpdate')) {
            return;
          }
          this.saveSuccess();
          this.$router.push({
            name: "system-account-detail",
            params: {
              accountId: this.paramsAccountId,
            },
          }).finally(()=>{
            this.showLoading = false
          });
        })
    },

    /**
     * 更新成功的提示
     */
    saveSuccess() {
      // TODO
      this.$messageIotSuccess(this.$t("message.common.updateSuccess", {
        field: this.$t("label.system.account.prompt.account"),
      }));
    },

    /**
     * テナントの場合、ロールを選択
     */
    selectRole(roles) {
      if (this.accountInfo.accountType.code === "04") {
        if (roles.length == 0) {
          for (let i = 0; i < this.roles.length; i++) {
            if (this.roles[i].code == "0402" || this.roles[i].code == "0403") {
              this.roles[i].isDisabled = true;
            }
          }
          return;
        }

        let managerFlag = false;
        let userFlag = false;
        let arr = [];

        for (let i = 0; i < roles.length; i++) {
          if (roles[i] == "0401") {
            for (let j = 0; j < this.roles.length; j++) {
              if (
                this.roles[j].code == "0402" ||
                this.roles[j].code == "0403"
              ) {
                this.roles[j].isDisabled = false;
              }
            }
            managerFlag = true;
            arr.push("0401");
          }
          if (roles[i] == "0404") {
            for (let j = 0; j < this.roles.length; j++) {
              if (this.roles[j].code == "0403") {
                this.roles[j].isDisabled = false;
              }
            }
            userFlag = true;
            arr.push("0404");
          }
        }

        for (let i = 0; i < roles.length; i++) {
          if (roles[i] == "0402") {
            if (managerFlag == true) {
              arr.push("0402");
            }
          }
          if (roles[i] == "0403") {
            if (managerFlag == true || userFlag == true) {
              arr.push("0403");
            }
          }
        }

        if (!managerFlag) {
          if (userFlag) {
            for (let j = 0; j < this.roles.length; j++) {
              if (this.roles[j].code == "0402") {
                this.roles[j].isDisabled = true;
              }
            }
          } else {
            for (let j = 0; j < this.roles.length; j++) {
              if (
                this.roles[j].code == "0403" ||
                this.roles[j].code == "0402"
              ) {
                this.roles[j].isDisabled = true;
              }
            }
          }
        }

        this.accountInfo.roles = [];
        for (let i = 0; i < arr.length; i++) {
          this.accountInfo.roles[i] = arr[i];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}
::v-deep .zdyselect {
  // margin-left: 80px;
  font-size: 15px;
  width: 188px !important;
  height: 40px;
  padding-bottom: 20px !important;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
    .el-input__inner {
    height: 40px;
    border-radius: 8px !important;
    background-color: #F2F2ED;
    border: 0;
    color: #525250;
  }
  .el-input__suffix {
    top: 0px;
  }
  .el-input__icon {
    line-height: 25px !important;
  }
}

::v-deep .new-input-style {
  .el-input__inner{
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}
.star-color {
  color: #e65245
}
.float-left {
  float:left;
}
.title-div {
  font-size: 20px;
  color: #525250;
}
.info-margin-left {
  margin-left: 200px;
}
.info-margin-top {
  margin-top: 40px;
}
.pick_date_box {
  width: 188px !important;
  height: 40px !important;
  border: none !important;
  background-color: #F7F7F2;
  ::v-deep .el-icon-date:before {
    display: none;
  }
  ::v-deep .el-icon-date:after {
    display: none;
  }
  ::v-deep.el-input__inner {
    width: 188px !important;
    height: 40px !important;
    font-size: 13px;
    padding-left: 20px;
    border: none;
    height: 40px;
    border-radius: 4px !important;
    background-color: #F2F2ED;
    box-shadow: -2px -2px 5px #ffffff ,4px 5px 5px #E6E6E1 ;
  }
}
.img-size {
  position: relative;
  margin-left: -30px;
  margin-bottom: -5px;
  -webkit-pointer-events: none;
  -moz-pointer-events: none;
  -ms-pointer-events: none;
  -o-pointer-events: none;
  pointer-events: none;
}
::v-deep .time-select {
  width: 120px;
  font-size: 15px;
  height: 40px;
  border-radius: 8px;
  padding-bottom: 20px !important;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
    .el-input__inner {
    height: 40px;
    border-radius: 10px;
    background-color: #F2F2ED;
    border: 0;
    color: #525250;
  }
  .el-input__suffix {
    top: 0px;
  }
  .el-input__icon {
    line-height: 25px !important;
  }
}
::v-deep .zdyselect {
  width: 120px;
  font-size: 15px;
  height: 40px;
  border-radius: 15px;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
  .el-input__inner {
    height: 40px;
    border-radius: 10px;
    background-color: #F2F2ED;
    border: 0;
    color: #525250;
  }
  .el-input__suffix {
    top: 0px;
  }
  .el-input__icon {
    line-height: 25px !important;
  }
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #525250;
}
.hr {
  height: 1px;
  width: 800px;
  background-color: #D1D1CD;
}
::v-deep .el-form-item__label:before {
  display: none;
}
::v-deep .asterisk {
  .el-form-item__label::after{
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
}
::v-deep .el-form-item__error {
  width: 500px;
}

.account-type-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .el-checkbox:hover .is-disabled .el-checkbox__inner::before {
  display: none;
}

::v-deep .el-form-item {
  margin-bottom: 40px;
}

::v-deep .time-select {
  margin: 0px;
}

::v-deep .el-row--flex.is-align-middle {
  align-items: normal;
}

.margin-top-0 {
  margin-top: 0px !important;
}

.line-height-44::v-deep {
  .el-form-item__label {
    line-height: 44px !important;
  }
}

.account-edit::v-deep {
  .el-form-item__label {
    font-size: 16px;
  }
}

.m-left-400 {
  margin-left: 400px;
}
.m-top-20 {
  margin-top: 20px;
}
</style>

